/* loaded by smart-asset */
export default require("./more_vert-24px~LibQHezD.svg")